import { Box } from '@mui/system';
import axios from 'axios';
import { useState } from 'react';
import { useQuery } from '../../../hooks/UseQuery';
import TController from './create/TController';
import useGetData from './helpers/useGetData';
import { Loader } from '../../../components/common/Loader';
import HeaderCreate from './HeaderCreate';
import { moduleConstant } from './constant';
import useConfirm from '../../../components/common/useConfirm';
import { CustomPagination } from '../../../components/common';
import Type from './dashboard/Type';

interface MyData {
  moduleData: any;
  isLoading: boolean;
  setModuleData: any;
  setRenderforUpdate: any;
  setParentRender: React.Dispatch<React.SetStateAction<boolean>>;
  error?: string | null;
  machineData: any;
  breakdownData: any;
  tabValue: any;
  totalPages: any;
  setTabValue: any;
}
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
const Create = () => {
  const date = useQuery('date');
  // const isView = useQuery('isView') === 'true' ? true : false;
  const [isView, setisView] = useState<boolean>(false);
  const [DialogUpdate, confirmUpdate] = useConfirm(
    'Save',
    'Are you sure you want to save?'
  );
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this row?'
  );

  const {
    error,
    moduleData,
    setModuleData,
    isLoading,
    setParentRender,
    setRenderforUpdate,
    machineData,
    breakdownData,
    tabValue,
    setTabValue,
    totalPages,
  }: MyData = useGetData();

  const handleUpdate = async () => {
    if (!date) {
      alert('date required');
      return;
    }
    const ans = await confirmUpdate();
    if (!ans) return;

    axios
      .post(`${moduleConstant.apiConstant}?date=${date}`, moduleData)
      .then((res) => {
        setRenderforUpdate((prev: any) => !prev);
        alert('successfully updated');
      })
      .catch((err) => console.error(err));
  };

  const handleDelete = async (id: string, rowIndex: number) => {
    const ans = await confirmDelete();
    if (!ans) return;
    if (!id) {
      const values = [...moduleData];
      values.splice(rowIndex, 1);
      setModuleData(values);
      alert('row deleted successfully');
      return;
    }
    await axios
      .delete(`${moduleConstant.apiConstant}/${id}`)
      .then((res) => {
        if (res.data) {
          const values = [...moduleData];
          values.splice(rowIndex, 1);
          setModuleData(values);
          alert('row deleted successfully');
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box>
      <Loader loader={isLoading} />
      <HeaderCreate
        {...{
          handleUpdate,
          moduleData,
          setModuleData,
          tabValue,
          setTabValue,
        }}
      />
      {tabValue<=1&&<TController
        {...{
          moduleData,
          isView,
          handleDelete,
          setModuleData,
          setParentRender,
          machineData,
          breakdownData,
          tabValue,
        }}
      />}
      {tabValue === 2 && (
            <Type
              apiData={moduleData}
              year={date ? new Date(date).getFullYear() : new Date().getFullYear()}
              title1="PARETO CHART"
              // vendors={vendors}
              // vendorName={vendorName}
               month={date ? monthNames[new Date(date).getMonth()] : ""}
            />
          )}
      {/* <CustomPagination totalPage={totalPages} /> */}

      <DialogUpdate isSubmitContent={false} />
      <DialogDelete isSubmitContent={false} />
    </Box>
  );
};

export default Create;
